import React from 'react';
import { Link } from 'react-router-dom';
import { TackNotificationsShape, UserShape } from '../../shapes';
import DateMaster from '../../stores/utils/date_master';
import UserTackProgress from '../user_tack_progress';
import Waiting from '../waiting';

import PropTypes from 'prop-types';

const SALUTATIONS = ['Salutations', 'Yo', 'Hello', 'Howdy', 'Good day', 'Hola', 'Greetings', 'Hiya', 'Hi', 'Hey', 'Greetings']

export default class TackBoardForToday extends React.Component {

  static propTypes = {
    user: UserShape,
    tackNotifications: TackNotificationsShape,
    onLoadTackNotifications: PropTypes.func
  }

  state = {
    randomSalutation: this.randomSalutation()
  }

  randomSalutation() {
    return SALUTATIONS[Math.floor(Math.random() * SALUTATIONS.length)];
  }

  componentDidMount() {
    this.props.onLoadTackNotifications();
  }

  render() {
    if (this.props.tackNotifications.get('loading')) {
      return this.renderLoading();
    } else if (this.props.tackNotifications.get('notifications').size == 0) {
      return this.renderNoNotifications();
    } else {
      return this.renderUnreadTackNotifications();
    }
  }

  renderLoading() {
    return(
      <Waiting waitingText={ 'Crunching' } />
    )
  }

  renderNoNotifications() {
    if (this.props.user.get('activeTacksCount') > 0) {
      return (
        <div className='no-notifications'>
          <h4>Nothing left on the Tack Board today.</h4>
          <div className='action'>
            <Link to='/tacks/trends/most_tacked' className='btn btn-dark'>Tack more words</Link>
          </div>
        </div>
      )
    } else {
      return (
        <div className='no-notifications'>
          <h4>No notifications on the Tack Board yet.</h4>
          <div className='action'>
            <Link to='/tack_board/active_tacks' className='btn btn-dark'>Start tacking</Link>
          </div>
        </div>
      )
    }
  }

  renderUnreadTackNotifications() {
    const unreadTackNotifications = this.props.tackNotifications.get('notifications')
      .filter(tackNotification => !tackNotification.get('readAt'))
      .map((tackNotification, i) => {
      return (
        <li key={ i } className='list-group-item list-group-item-action'>
          <Link to={ `/tack_board/${ tackNotification.get('wordText') }/notification/${ tackNotification.get('slug') }` }>
            { this.renderTackNotification(tackNotification) }
          </Link>
        </li>
      );
    });
    if (unreadTackNotifications.size > 0) {
      return (
        <div>
          <div className='secondary-background instruction-text'>
            { `${ this.state.randomSalutation }! Click each word below.` }
          </div>
          <div className='board-notification-group'>
            <ul className='list-group'>{ unreadTackNotifications }</ul>
          </div>
        </div>
      );
    } else return null;
  }

  renderTackNotification(tackNotification) {
    if (tackNotification.get('isArchive')) {
      return this.renderArchiveTackNotification(tackNotification);
    } else {
      return this.renderUnreadTackNotification(tackNotification);
    }
  }

  renderUnreadTackNotification(tackNotification) {
    return (
      <div className='row'>
        <div className='col-sm-4'>
          <h4 className='board-notification-item'>{ tackNotification.get('wordText') }</h4>
        </div>
        <div className='col-sm-4'><UserTackProgress currentInterval={ tackNotification.get('tackInterval') }></UserTackProgress></div>
        <div className='col-sm-4 item-meta'>{ `sent ${ DateMaster.timeSince(tackNotification.get('createdAt')) } ago` }</div>
      </div>
    );
  }

  renderArchiveTackNotification(tackNotification) {
    return (
      <div className='row'>
        <div className='col-sm-4'>
          <h4>{ tackNotification.get('wordText') }</h4>
        </div>
        <div className='col-sm-4'>archive</div>
        <div className='col-sm-4 item-meta'>{ `finished ${ DateMaster.timeSince(tackNotification.get('lastSentDate')) } ago` }</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/tack_board/tack_board_for_today.jsx